





















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DropZone extends Vue {
  @Prop({ default: true })
  private enabled!: boolean;

  private hightlight = false;

  onDragOver(event: DragEvent): void {
    if (!this.enabled) {
      return;
    }
    event.preventDefault();
    this.hightlight = true;
  }

  onDragLeave(): void {
    this.hightlight = false;
  }

  onDrop(event: DragEvent): void {
    if (!this.enabled) {
      return;
    }
    event.preventDefault();
    const file = event.dataTransfer?.files[0];
    if (file) {
      const imageTypes = ["image/png", "image/gif", "image/bmp", "image/jpeg"];
      if (imageTypes.includes(file.type)) {
        this.readImage(file);
      }
    }
    this.hightlight = false;
  }

  onFileChanged(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input?.files) {
      const [file] = input.files;
      this.readImage(file);
    }
  }

  readImage(file: File) {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      this.$emit("image-uploaded", url, image.width, image.height);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
    };
    image.src = url;
  }

  openFileSelection(): void {
    if (!this.enabled) {
      return;
    }
    (this.$refs.fileInput as HTMLElement).click();
  }
}
